// The broker's text permission doors (people-create-door T7e, DA3):
// routes/tracon-sms-permission.routes.js. The store's answer is the only
// permission; these record what David heard, each with a required reason.
import { api } from '@/lib/api.js';

export function getSmsPermission(phone) {
  return api.get(`/api/tracon/sms-permission?phone=${encodeURIComponent(phone)}&_t=${Date.now()}`);
}

// Heard by David (by phone, in person). Also lifts a STOP the number texted.
export function recordSmsPermission({ phone, reason, crmContactId } = {}) {
  return api.post('/api/tracon/sms-permission/grant', { phone, reason, crm_contact_id: crmContactId || undefined });
}

// "Stop texting" as told to David. Reads as no permission, not as the number's own STOP.
export function stopSmsPermission({ phone, reason } = {}) {
  return api.post('/api/tracon/sms-permission/revoke', { phone, reason });
}
